// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"88022854","100":"bed7ecea","109":"7d8308bc"}[chunkId] + ".chunk.js";
};